module.exports = __webpack_public_path__ + "static/media/McKinsey.32df3f15.png";